import React from "react";
import PropTypes from "prop-types";
import { Button, Panel } from "react-bootstrap";
import classNames from "classnames";

const ExpandableSection = ({
	title,
	expanded,
	handleToggle,
	className,
	headerClassName,
	bodyClassName,
	link,
	linkAction,
	children,
	showArrow,
}) => {
	const handleLinkAction = e => {
		e.preventDefault();
		e.stopPropagation();
		linkAction();
	};

	return (
		<Panel
			expanded={expanded}
			className={classNames("simple-collapse", className)}
			onToggle={handleToggle}
		>
			<Panel.Heading
				className={classNames(
					headerClassName,
					expanded ? "panel-expanded" : "panel-collapsed",
				)}
			>
				<Panel.Title toggle>
					<div className="title-content">
						<div className="title-text">
							<div className="main-title">{title}</div>
						</div>
						<If condition={link !== ""}>
							<div className="margin-left-10">
								<Button
									bsStyle="link"
									className="btn-blue-small"
									onClick={handleLinkAction}
								>
									{link}
								</Button>
							</div>
						</If>
						<If condition={showArrow}>
							<div
								className={classNames(
									"margin-left-20 title-expand-icon",
									expanded ? "panel-expanded" : "panel-collapsed",
								)}
							>
								<i className="rkf rkf-chevron-up" />
							</div>
						</If>
					</div>
				</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<Panel.Body className={bodyClassName}>{children}</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

ExpandableSection.propTypes = {
	title: PropTypes.string.isRequired,
	expanded: PropTypes.bool.isRequired,
	handleToggle: PropTypes.func.isRequired,
	className: PropTypes.string,
	headerClassName: PropTypes.string,
	bodyClassName: PropTypes.string,
	link: PropTypes.string,
	linkAction: PropTypes.func,
	children: PropTypes.any.isRequired,
	showArrow: PropTypes.bool,
};

ExpandableSection.defaultProps = {
	className: "",
	headerClassName: "",
	bodyClassName: "",
	link: "",
	linkAction: () => {},
	showArrow: true,
};

export default ExpandableSection;
